// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1jwFj","select":"Header_select__3JyTO","clinic":"Header_clinic__1qUAu"};